<template>
  <div class="content">
    <HeaderProductResale
      title="Produtos"
      text="Veja a lista completa dos produtos que você tem em estoque."
      actionTitle="Adicionar produto"
      :haveAction="true"
      @action="goToSelect('/product-select')"
    >
      <v-btn
        outlined
        class="ml-3"
        style="border-radius: 10px; width: 250px"
        @click="getExcel"
      >
        Exportar SKU's
      </v-btn>

      <v-btn
        outlined
        class="ml-3 mt-4"
        style="border-radius: 10px; width: 250px"
        @click="openPicker"
      >
        Importar SKU's
      </v-btn>
    </HeaderProductResale>

    <v-file-input
      id="excel-input"
      class="d-none"
      accept=".xlsx"
      @change="importExcel"
    ></v-file-input>

    <v-container style="max-width: unset" class="pa-6 pt-2">
      <v-card
        transition="scale-transition"
        v-if="true"
        class="d-column mt-0 mb-6 py-2"
        elevation="0"
        color="#FFFFFF"
        style="border-radius: 6px"
      >
        <!-- Primeira linha de filtro -->
        <v-row class="py-3 px-6 ma-0">
          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="3"
            md="3"
            sm="6"
          >
            <v-text-field
              outlined
              class="px-0"
              style="
                border: 1px solid #979797;
                border-radius: 7.5px;
                width: 100%;
              "
              color="black"
              background-color="#F5F5F5"
              hide-details
              placeholder="Nome do Produto"
              v-model="filter.product"
              attach
              v-on:keyup="filterTable"
              :loading="loading"
            >
              <template v-slot:append>
                <v-icon class="pt-0" color="normalred" size="26"
                  >mdi-magnify</v-icon
                >
              </template>
            </v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
          >
            <v-autocomplete
              color="black"
              clearable
              v-model="filter.productCategory"
              attach
              :items="categories"
              item-text="categoryName"
              item-value="categoryId"
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              placeholder="Categoria"
              @change="filterTable"
              :loading="loading"
            ></v-autocomplete>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
          >
            <v-text-field
              color="black"
              clearable
              v-model="filter.productType"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              placeholder="Tipo"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="3"
            md="4"
            sm="6"
          >
            <v-btn
              :outlined="!showAllFilters"
              block
              color="black"
              dark
              elevation="0"
              height="56"
              style="border-radius: 7.5px"
              @click="showAllFilters = !showAllFilters"
            >
              <v-icon class="ma-0 pa-0">mdi-filter</v-icon>
              Abrir todos os filtros
            </v-btn>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
          >
            <v-btn
              block
              outlined
              height="56"
              style="border-radius: 7.5px"
              @click="reset"
              >Limpar filtros
            </v-btn>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
            v-if="showAllFilters"
          >
            <v-autocomplete
              color="black"
              clearable
              v-model="filter.ProductSubCategory"
              :items="subCategories"
              item-text="name"
              item-value="subCategoryId"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              label="Subcategoria"
              placeholder="Subcategoria"
              @change="filterTable"
              :loading="loading"
            ></v-autocomplete>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
            v-if="showAllFilters"
          >
            <v-text-field
              color="black"
              clearable
              v-model="filter.productApplication"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              placeholder="Aplicação"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
            v-if="showAllFilters"
          >
            <v-text-field
              color="black"
              v-model="filter.maxValue"
              :key="maxValueKey"
              v-money="money"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              label="Valores Até"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
            v-if="showAllFilters"
          >
            <v-autocomplete
              color="black"
              clearable
              v-model="filter.order"
              :items="orders"
              item-text="text"
              item-value="value"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              placeholder="Ordem alfabetica"
              @change="filterTable"
              :loading="loading"
            ></v-autocomplete>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
            v-if="showAllFilters"
          >
            <v-text-field
              color="black"
              v-model="filter.value"
              v-money="money"
              :key="valueKey"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              label="Valor"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card>

      <v-data-table
        id="product-resale-table"
        loading-text="Carregando..."
        no-data-text="Nenhum produto encontrado"
        class="elevation-0"
        hide-default-footer
        :headers="headers"
        :items="products"
        :loading="loading"
        :items-per-page="pageSize"
        :header-props="headerProps"
        v-model="selectedProdcts"
        show-select
        item-key="id"
        :single-select="false"
      >
        <template v-slot:[`item.productSku.product.productPic`]="{ item }">
          <div class="d-flex pa-3">
            <v-img
              :src="item.productSku.product.productPic"
              :alt="item.productName"
              class="imgProduct"
              width="80"
              height="50"
            ></v-img>
          </div>
        </template>

        <template v-slot:[`item.productName`]="{ item }">
          <span class="product-name-field">
            {{ item.productName }}
          </span>
        </template>

        <template v-slot:[`item.productSku`]="{ item }">
          <span v-if="item.price" class="product-name-field">
            {{
              item.price.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </span>
          <span v-else class="product-name-field">
            {{
              item.productSku.differentValue.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </span>
        </template>

        <template v-slot:[`item.productSku.sku`]="{ item }">
          <span class="product-name-field">
            {{
              item.productSku &&
              item.productSku.attributes &&
              item.productSku.attributes.length > 0
                ? item.productSku.attributes[0].name
                : "Sem registro"
            }}
          </span>
        </template>

        <template v-slot:[`item.productSku.product.categories.category`]="{ item }">
          {{
            item.productSku.product.categories.length > 0
              ? item.productSku.product.categories[0].category
              : "Sem registros"
          }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                fab
                tile
                style="border-radius: 6px"
                small
                class="ma-1 table-button"
                @click="editProduct(item.productSku)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                fab
                tile
                style="border-radius: 6px"
                small
                class="ma-1 remove-button"
                color="red"
                @click="deleteProduct(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
            <span>Remover</span>
          </v-tooltip>
        </template>

        <template v-slot:header.data-table-select="{ on, props}">
          <v-simple-checkbox
              color="#bc0000"
              v-bind="props"
              v-on="on"
              :ripple="false"
          >
          </v-simple-checkbox>
        </template>

        <template v-slot:item.data-table-select="{ on, props, isSelected, item }">
          <v-simple-checkbox
              :ripple="false"
              @click="addProductListSelectedProdcts(item)"
              :value="isSelected"
              color="#bc0000"
              v-bind="props"
              v-on="on"
          >
          </v-simple-checkbox>
        </template>

        <template v-slot:footer >
          <section class="ma-0 pa-0">
            <Pagination
                v-if="totalItems > pageSize"
                :currentPage="currentPage"
                :totalItems="totalItems"
                :page="page"
                :pageSize="pageSize"
                :totalPages="totalPages"
                @back-page="backPage"
                @next-page="nextPage"
            >
            </Pagination>
          </section>

          <v-row cols="12" class="mx-0 mb-0 mt-1 " v-if="selectedProdcts.length > 0">
            <v-col cols="12" class="ma-0 pa-0 pa-0 mb-0 mt-2">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 pa-0 mb-0 mt-2">
              <label>Selecione a ação</label>
              <v-select
                  class="ma-0 pa-0 "
                  dense
                  v-model="actionSelected"
                  outlined
                  style="border-radius: 3px!important"
                  :items="actions"
                  item-text="label"
                  item-value="value"
                  placeholder="Selecione a ação"
              >
              </v-select>
            </v-col>

            <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="ma-0 pa-0 mt-2">
              <v-btn
                  class="secondary-button mt-5 ml-3"
                  style="height: 40px!important; border-radius: 7.5px!important"
                  height="40"
                  width="100%"
                  elevation="0"
                  :disabled="!actionSelected"
                  @click="confirmActionDialog = true"
              >
                {{ actionSelected ? actions.find((x) => x.value === actionSelected).label : 'Selecione a ação'}}
              </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-container>

    <!-- Modal Historico -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="logDialog"
      max-width="650px"
    >
      <LogModal
        title="Histórico do produto"
        :product="this.currentProduct"
        cancelBtn="Voltar"
        :icone="'mdi-update'"
        @close="(logDialog = false), updateTable()"
        @action="logDialog = false"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- ChangeStock Dialog  -->
    <v-dialog v-model="stockDialog" max-width="450px">
      <AprovalStockModal
        :title="'Aleração de estoque.'"
        :textMessage="aprovalStockConfirm"
        cancelBtn="Cancelar"
        :okbtn="'SIM'"
        textObservation=""
        icone="mdi-restore-alert"
        @close="(stockDialog = false), updateTable()"
        @action="(stockDialog = false), changeStock()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- ChangeStatus Dialog  -->
    <v-dialog v-model="changeDialog" max-width="450px">
      <AprovalModal
        :title="
          this.currentProduct.status == 1
            ? 'Ativar produto'
            : 'Inativar produto'
        "
        :textMessage="aprovalConfirm"
        cancelBtn="Cancelar"
        :okbtn="this.currentProduct.status == 1 ? 'ATIVAR' : 'INATIVAR'"
        textObservation=""
        icone="mdi-restore-alert"
        @close="(changeDialog = false), updateTable()"
        @action="(changeDialog = false), changeStatus()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- Dialog DETAILS  -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="detailsDialog"
      max-width="950px"
    >
      <Details2Product
        :productId="this.currentProduct"
        title="Detalhar Produto"
        @action="detailsDialog = false"
        @close="(detailsDialog = false), filterTable()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- Modal deletar -->
    <v-dialog v-model="deleteDialog" max-width="450px">
      <DeleteModal
        title="Deletar"
        textMessage="Tem certeza que deseja deletar esse sku?"
        cancelBtn="Cancelar"
        okbtn="Deletar"
        textObservation=""
        @close="(deleteDialog = false), updateTable()"
        @action="(deleteDialog = false), remove()"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <v-dialog v-model="confirmActionDialog" max-width="450">
      <ConfirmModal
          v-if="actionSelected"
          title=""
          textMessage=""
          :textObservation1="`Deseja realmente ${actions.find((x) => x.value === actionSelected).label} selecionados?`"
          textObservation2=""
          cancelBtn="Cancelar"
          okbtn="Sim"
          textObservation=""
          @close="(confirmActionDialog = false)"
          @action="removeProducts()"
      />
    </v-dialog>
  </div>
</template>

<style scoped>
.remove-button {
  border: 2px solid #bc0000;
  border-radius: 4px;
}

.remove-button:hover {
  background: #bc0000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  color: white !important;
}

.table-button {
  border: 2px solid #2d3038;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: bold;
  transition: 300ms;
}

.table-button:hover {
  background: #2d3038;
  color: white !important;
}

.table-button:focus {
  background: #444854;
  color: white !important;
}

.content {
  background: #e5e5e5;
}

.stock-field {
  min-height: 25px;
  text-align-last: center;
  width: 60px !important;
}

.imgProduct {
  background-position: center center;
  border-radius: 20px;
}

.item {
  background: #424242 !important;
}

.item span {
  font-size: 1.05rem;
  color: #fff;
}

.back {
  background: #e9e9e9 !important;
  max-width: unset;
}

.filterAutocomplete {
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
}

.table-button {
  font-weight: bold;
  transition: 300ms;
}

.table-button:hover {
  background: #2d3038;
  color: white !important;
}

.table-button:focus {
  background: #444854;
  color: white !important;
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}

@media (max-width: 860px) {
  .table-header {
    display: none;
  }
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import HeaderProductResale from "./components/HeaderProductResale.vue";
import Details2Product from "./components/Details2Product.vue";
import AprovalModal from "../components/AprovalModal.vue";
import AprovalStockModal from "../components/AprovalModal.vue";
import DeleteModal from "../components/DeleteModal.vue";
import LogModal from "./components/LogModal.vue";
import { VMoney } from "v-money";
import ConfirmModal from "@/views/pages/components/ConfirmModal.vue";
import Vue from "vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  components: {
    ConfirmModal,
    Pagination,
    HeaderProductResale,
    Details2Product,
    AprovalModal,
    DeleteModal,
    LogModal,
    AprovalStockModal,
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.getCategories();
    this.getSubCategories();

    this.productName = null;
    this.productsId = null;

    const jsonFilters = localStorage.getItem("filters-resale");

    if (jsonFilters) {
      this.filter = JSON.parse(localStorage.getItem("filters-resale"));
      this.page = this.filter.page;
    }
    this.updateTable();

    this.env_url = process.env.VUE_APP_BASE_URL;
  },

  data: () => ({
    selectedProdcts: [],
    actions: [
      { label: "Excluir Produtos(s)", value: 1},
    ],
    actionSelected: null,
    confirmActionDialog: false,
    user: {},
    statusLoading: false,
    showAllFilters: false,
    categories: [],
    env_url: "",
    logDialog: false,
    stockDialog: false,
    changeDialog: false,
    disableStatus: false,
    currentProduct: {},
    detailsDialog: false,
    importDialog: false,
    excelDialog: false,
    products: [],
    productsId: [],
    status: [
      { label: "Inativo", value: 0 },
      { label: "Ativo", value: 1 },
    ],
    error: false,
    show: false,
    dialog: false,
    closeNoLoading: false,
    editDialog: false,
    addDialog: false,
    aboutDialog: false,
    deleteDialog: false,
    dialogKey: false,
    loading: false,
    isLoading: false,
    page: 1,
    totalPages: 1,
    currentPage: 1,
    totalItems: 1,
    pageSize: 15,
    sizes: [15, 30, 90, 180],
    apiService: new ApiService(),
    filter: {
      resaleId: null,
      page: 1,
      pageSize: 15,
      product: "",
      productCategory: 0,
      productType: "",
      productApplication: "",
      maxValue: "",
      value: "",
    },
    headers: [
      {
        text: "Código",
        class: "item",
        value: "productSku.product.productCode",
        align: "start",
        sortable: false,
      },
      {
        text: "Foto",
        class: "item",
        value: "productSku.product.productPic",
        align: "start",
        sortable: false,
      },
      {
        text: "Nome",
        class: "item",
        value: "productSku.product.productName",
        align: "start",
        sortable: false,
      },
      {
        text: "SKU",
        class: "item",
        value: "productSku.sku",
        align: "start",
        sortable: false,
      },
      {
        text: "Preço de venda",
        class: "item",
        value: "productSku",
        align: "start",
        sortable: false,
      },
      {
        text: "Estoque",
        class: "item",
        value: "quantity",
        align: "start",
        sortable: false,
      },
      {
        text: "Vendas",
        class: "item",
        value: "productSku.product.vendas",
        align: "start",
        sortable: false,
      },
      {
        text: "Ações",
        class: "item",
        value: "actions",
        align: "center",
        sortable: false,
      },
    ],
    money: {
      decimal: ",",
      thousands: ".",
      precision: 2,
      masked: false,
    },
    maxValueKey: false,
    valueKey: false,
    orders: [
      {
        text: "Crescente",
        value: 0,
      },
      {
        text: "Decrescente",
        value: 1,
      },
    ],
    headerProps: { sortByText: "Ordenar por" },
  }),

  directives: { money: VMoney },

  computed: {
    aprovalStockConfirm() {
      return `Tem certeza que deseja alterar o estoque desse produto?`;
    },

    aprovalConfirm() {
      return `Tem certeza que deseja ${
        this.currentProduct.status == 1 ? "ativar" : "inativar"
      } este produto ?`;
    },
  },

  methods: {
    removeProducts(){
      try {
        this.confirmActionDialog = false;
        this.apiService.post('resaleproductsku/delete/list', this.selectedProdcts).then(async (response) => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "success",
            title: "",
            message: "Produtos excluídos com sucesso",
            trace: null,
          });
          await this.updateTable()
        }).catch(() => {
          Vue.$globalEvent.$emit("onFlashMessage", {
            type: "error",
            title: "",
            message: "Não foi possível excluir os produtos",
            trace: null,
          });
        })
      } catch (e) {

      }
    },

    addProductListSelectedProdcts(product){
      const productFind = this.selectedProdcts.findIndex((x) => x.id === product.id)
      if (productFind > -1) {
        this.selectedProdcts.splice(productFind, 1)
      } else {
        this.selectedProdcts.push(product)
      }
    },

    getCategories() {
      this.apiService.get("category/list").then((response) => {
        this.categories = response;
      });
    },

    async getSubCategories() {
      this.apiService.get("subCategory/listAll").then((response) => {
        this.subCategories = response;
      });
    },

    logProduct(item) {
      this.currentProduct = item;
      this.dialogKey = !this.dialogKey;
      this.logDialog = true;
    },

    async remove() {
      this.loading = true;
      const doneByAdminOrMasterUser = false;
      await this.apiService
        .delete(`resaleproductsku/delete/${this.currentProduct.id}/${this.user.id}/${doneByAdminOrMasterUser}`)
        .then(() => {
          this.updateTable();
          this.loading = false;
          this.deleteDialog = false;
        })
        .catch(() => {
          this.loading = false;
          this.deleteDialog = false;
        });
    },

    toggleChangeDialog(item) {
      this.approveSelectedItem = item;
      this.currentProduct = item;
      this.dialogKey = !this.dialogKey;
      this.changeDialog = true;
    },

    changeStatus(item) {
      item = this.approveSelectedItem;
      if (item.status == 0) {
        item.status = 1;
      } else if (item.status == 1) {
        item.status = 0;
      }

      this.editStatus(item);
    },

    async editStatus(item) {
      this.loading = true;
      this.currentProduct = item;
      await this.apiService
        .post(`resaleproductsku/changestatus`, this.currentProduct)
        .then(() => {
          this.updatePageView();
          this.loading = false;
        })
        .catch((erro) => {
          this.loading = false;
        });
    },

    toggleStockDialog(item) {
      this.approveSelectedItem = item;
      this.currentProduct = item;
      this.dialogKey = !this.dialogKey;
      this.stockDialog = true;
    },

    changeStock(item) {
      item = this.approveSelectedItem;

      this.editStock(item);
    },

    async editStock(item) {
      this.loading = true;
      this.currentProduct = item;
      await this.apiService
        .post(`resaleproductsku/changestock`, this.currentProduct)
        .then((response) => {
          this.loading = false;
          this.updatePageView();
        })
        .catch((erro) => {
          this.loading = false;
        });
    },

    async updatePageView() {
      this.filter.Status = null;
      await this.updateTable();
      // this.countStatus =
      // this.countStatusInativos = this.resales.filter((resale) => resale.status == 0).length;
    },

    showSuccess(message) {
      this.$emit("show", message);
    },

    detailsProduct(products) {
      this.currentProduct = products;
      this.dialogKey = !this.dialogKey;
      this.detailsDialog = true;
    },

    async goToSelect(item) {
      localStorage.setItem("filters-resale", JSON.stringify(this.filter));
      await this.$router.push({
        path: item,
      });
    },

    async editProduct(item) {
      console.log(item)
      localStorage.setItem("filters-resale", JSON.stringify(this.filter));
      await this.$router.push({
        path:
          "/product-addresale?isEditing=true&id=" +
          item.productId +
          "&product=" +
          item.product.productName +
          "&status=" +
          item.status,
        params: item,
      });
    },

    closeDialog() {
      this.dialog = false;
      this.editDialog = false;
      this.updateTable();
    },

    deleteProduct(item) {
      this.currentProduct = item;
      this.dialogKey = !this.dialogKey;
      this.deleteDialog = true;
    },

    filterTable() {
      this.loading = true;
      this.filter.pageSize = this.pageSize;
      this.filter.page = this.page;

      this.updateTable();
      this.filterDialog = false;
    },

    openPicker() {
      document.getElementById("excel-input").click();
    },

    async importExcel() {
      let file;
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        file = reader.result;
        this.doExcelImport(file);
      };
    },

    async doExcelImport(media) {
      this.apiService
        .post("resaleproductsku/excel/import", { media })
        .then((resp) => {
          this.$toast.success("Excel importado com sucesso");
          this.updateTable();
        });
    },

    async getExcel() {
      await this.apiService
        .post(`resaleproductsku/excel`, this.filter)
        .then((response) => {
          var excelResult = `data:application/octet-stream;base64,${response}`;
          const link = document.createElement("a");
          link.href = excelResult;
          link.setAttribute("download", "skus.xlsx");
          document.body.appendChild(link);
          link.click();
        });
    },

    async updateTable() {
      this.loading = true;
      this.isLoading = true;

      this.filter.maxValue =
        typeof this.filter.maxValue == "string"
          ? parseFloat(this.filter.maxValue.replace(".", "").replace(",", "."))
          : this.filter.maxValue;

      this.filter.value =
        typeof this.filter.value == "string"
          ? parseFloat(this.filter.value.replace(".", "").replace(",", "."))
          : this.filter.value;
      this.filter.resaleId = this.user.id

      await this.apiService
        .post(`resaleproductsku/list`, this.filter)
        .then((response) => {
          this.products = response.products;
          this.totalPages = response.pager.totalPages;
          this.currentPage = response.pager.currentPage;
          this.totalItems = response.pager.totalItems;
          this.loading = false;
          this.isLoading = false;
        });
    },



    async backPage() {
      this.page -= 1;
      this.filter.page = this.page;
      await this.updateTable();
    },

    async nextPage() {
      this.page += 1;
      this.filter.page = this.page;
      await this.updateTable();
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: 15,
      };
      this.page = 1;
      localStorage.removeItem("filters-resale");
      this.maxValueKey = !this.maxValueKey;
      this.valueKey = !this.valueKey;

      this.updateTable();
      this.filterDialog = false;
    },
  },

  watch: {},
};
</script>
